import { Container } from '@mui/material';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import Page from '../../../components/Page';
import { useParams } from 'react-router-dom';
import FAQForm from './FAQForm';

const index = () => {
  const params: any = useParams();
  const isAddMode = !params?.id;
  return (
    <Page title={'FAQ'}>
      <Container maxWidth={'xl'}>
        <HeaderBreadcrumbs
          heading={`${isAddMode ? 'Add FAQ' : 'Edit FAQ'} `}
          links={[
            { name: 'Dashboard', href: '/' },
            { name: 'FAQ', href: '/faq' },
          ]}
        />
        <FAQForm />
      </Container>
    </Page>
  );
};

export default index;
